export function getFromData(store, path) {
    return store.getters['page/getFromData'](path);
}
